<button type="button" mat-button mat-raised-button color="primary" class="display-text-button" (click)="openDialog()">
	<span>Merge Children</span>
</button>